module.exports = __webpack_public_path__ + "static/media/olivia.5e57125a.jpg";